import { render, staticRenderFns } from "./HostHealth.vue?vue&type=template&id=4b5f70a8&"
import script from "./HostHealth.vue?vue&type=script&lang=js&"
export * from "./HostHealth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports